import { render, staticRenderFns } from "./CdModal.vue?vue&type=template&id=33d71980&scoped=true&"
import script from "./CdModal.vue?vue&type=script&lang=js&"
export * from "./CdModal.vue?vue&type=script&lang=js&"
import style0 from "./CdModal.vue?vue&type=style&index=0&id=33d71980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d71980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d71980')) {
      api.createRecord('33d71980', component.options)
    } else {
      api.reload('33d71980', component.options)
    }
    module.hot.accept("./CdModal.vue?vue&type=template&id=33d71980&scoped=true&", function () {
      api.rerender('33d71980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atomicUIComponents/modal/CdModal.vue"
export default component.exports